import React from 'react';
import fetch from '../../fetch'
import utils from './../../../utils';
import {Tag} from 'antd';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            status: d.status,
            label: d.label,
            // label: d.label+"("+(+d.status === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d.status === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d.status === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>待提交</Tag>)+")",
            // label: d.label+(+d.status === 0 ? "--待提交" :+d.status === 1 ? "--待审核" : +d.status === 2 ? "--审核通过" : +d.status === 3 ? "--审核不通过" : ""),
            // label: <span>{d.label}  {(+d.status === 0 ? <Tag color='#1890ff'>待提交</Tag>:+d.status === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d.status === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d.status === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : "")}</span>,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const querySearch = (id) => {
    if(id){
        return fetch.get('template/getTemplateTreeById/' +id)
        .then(response => {
            return response.payload.data
        })
        .then(result => {
            const tree = utils.tree(result);
            const data =  transform(tree);
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
    }
}

const getTemplateById = (id) => {
    return fetch.get('template/get/'+id)
    .then(response => {
        return response.payload.data
    })
}

const getTemplateVoById = (id) => {
    return fetch.get('template/getTemplateVo/'+id)
    .then(response => {
        return response.payload.data
    })
}

const getSelfContentById = (id) => {
    return fetch.get('graduation/result/get/selfContent/' +id)
}

const selectLegislation = (data) => {
    return fetch.post('graduation/entring/selectLegislation', data);
}

const templateSave = (data) => {
    return fetch.post('graduation/entring/templateSave', data);
}

const studentTemplateSave = (data) => {
    return fetch.post('graduation/entring/studentTemplateSave', data);
}

const onSubmit = (id) => {
    return fetch.get('graduation/entring/onSubmit/' +id)
}

export default{
    upload : `${fetch.base}graduation/entring/file`,
    getTemplateById,
    querySearch ,
    getSelfContentById,
    selectLegislation,
    templateSave,
    onSubmit,
    getTemplateVoById,
    studentTemplateSave,
}